var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInsightIcon = function SvgInsightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "currentColor",
    viewBox: "0 0 18 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.371 3.047a.75.75 0 0 0-.215-.528.73.73 0 0 0-1.04 0 .75.75 0 0 0-.216.528v12.456c0 .412.33.747.736.747h14.222a.73.73 0 0 0 .52-.219.753.753 0 0 0 0-1.057.73.73 0 0 0-.52-.219H2.371zm14.007 2.521a.754.754 0 0 0-.018-1.038.73.73 0 0 0-1.022-.018l-4.63 4.703-2.422-2.461a.73.73 0 0 0-1.04 0L4.058 9.992a.754.754 0 0 0 .018 1.038.73.73 0 0 0 1.022.019l2.668-2.71 2.423 2.46a.73.73 0 0 0 1.04 0z",
    clipRule: "evenodd"
  })));
};
export default SvgInsightIcon;